import {
  FaPlus,
  FaTimes,
  FaSave,
  FaPen,
  FaMapMarkerAlt,
  FaUser,
  FaFlag,
  FaChartPie,
  FaClock,
  FaEye,
  FaCube,
  FaPencilAlt,
  FaFileAlt,
  FaCheck,
  FaImage,
  FaCubes,
  FaDownload,
  FaUpload,
  FaCrutch,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
  FaImages,
  FaFileAudio,
  FaFileImage,
  FaFilePdf,
  FaFile,
  FaFileVideo,
  FaPassport,
  FaUnity,
  FaList,
  FaCircle,
  FaSquare,
  FaShare,
  FaEnvelope,
  FaBookmark,
  FaChevronLeft,
  FaArrowRight,
} from "react-icons/fa";
import {
  FaCircleQuestion,
  FaGroupArrowsRotate,
  FaMagnet,
  FaScrewdriverWrench,
  FaSquareCheck,
  FaTableCells,
} from "react-icons/fa6";
import { IoTrashBin } from "react-icons/io5";
import { GiRelicBlade } from "react-icons/gi";
import ChemiNovaEntityType from "../model/enums/ChemiNovaEntityType";

class AppIcons {
  public static ADD = (<FaPlus />);
  public static ALTERATION_FORMS = (<FaCrutch />);
  public static ANNOTATIONS = (<FaPencilAlt />);
  public static ARROW_RIGHT = (<FaArrowRight />);
  public static BACK = (<FaChevronLeft />);
  public static CANCEL = (<FaTimes />);
  public static CHECK = (<FaCheck />);
  public static CHEVRON_DOWN = (<FaChevronDown />);
  public static CHEVRON_UP = (<FaChevronUp />);
  public static CH_ELEMENT = (<GiRelicBlade />);
  public static CIRCLE = (<FaCircle />);
  public static CLOCK = (<FaClock />);
  public static CLOSE = (<FaTimes />);
  public static COLLECTION = (<FaBookmark />);
  public static DASHBOARD = (<FaChartPie />);
  public static DELETE = (<IoTrashBin />);
  public static DETAIL_LEVEL = (<FaCubes />);
  public static DOCUMENTS = (<FaFileAlt />);
  public static DOWNLOAD = (<FaDownload />);
  public static E3D = (<FaCube />);
  public static EYE = (<FaEye />);
  public static EDIT = (<FaPen />);
  public static EMAIL = (<FaEnvelope />);
  public static FILE = (<FaFile />);
  public static FILE_IMAGE = (<FaFileImage />);
  public static FILE_PDF = (<FaFilePdf />);
  public static FILE_SOUND = (<FaFileAudio />);
  public static FILE_VIDEO = (<FaFileVideo />);
  public static GRID = (<FaTableCells />);
  public static GUID = (<FaPassport />);
  public static IMAGES = (<FaImages />);
  public static INFO = (<FaCircleQuestion />);
  public static LIST = (<FaList />);
  public static MAP = (<FaMapMarkerAlt />);
  public static MATERIALS = (<FaMagnet />);
  public static PILOT = (<FaGroupArrowsRotate />);
  public static SAVE = (<FaSave />);
  public static SEARCH = (<FaSearch />);
  public static SHARE = (<FaShare />);
  public static SITE = (<FaFlag />);
  public static SQUARE = (<FaSquare />);
  public static SQUARE_CHECK = (<FaSquareCheck />);
  public static TEXTURES = (<FaImage />);
  public static TOOLS = (<FaScrewdriverWrench />);
  public static UNITY = (<FaUnity />);
  public static UPLOAD = (<FaUpload />);
  public static USER = (<FaUser />);
  public static WATCHLIST = (<FaEye />);

  public static getIconByEntityType(type: ChemiNovaEntityType) {
    switch (type) {
      case ChemiNovaEntityType.CHELEMENT:
        return AppIcons.CH_ELEMENT;
      case ChemiNovaEntityType.E3DMODEL:
        return AppIcons.E3D;
      case ChemiNovaEntityType._3DINSTANCE:
        return AppIcons.E3D;
      case ChemiNovaEntityType.ANNOTATION:
        return AppIcons.ANNOTATIONS;
    }
    return undefined;
  }

  public static getIconForFile(filename: string) {
    // extract extension from file name
    const parts = filename.split(".");
    let extension = "";
    if (Array.isArray(parts)) {
      extension = parts[parts.length - 1];
    }
    // check which extension we have
    switch (extension) {
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "bmp":
        return AppIcons.FILE_IMAGE;
      case "pdf":
        return AppIcons.FILE_PDF;
      case "flv":
      case "avi":
      case "mp4":
      case "webm":
        return AppIcons.FILE_VIDEO;
      case "mp3":
      case "wav":
        return AppIcons.FILE_SOUND;
    }
    return AppIcons.FILE;
  }
}
export default AppIcons;
